export default "__VITE_ASSET__17b1a07d__"